import { Popover, PopoverContent, PopoverTrigger } from '@teamsnap/snap-ui';
import * as React from 'react';
import './TruncateWithPopover.scss';

interface Props {
  text: string;
  maxLength: number;
  style?: Record<string, string>;
}

export function truncateText(text: string, maxLength: number): string {
  if (text.length <= maxLength) {
    return text;
  }
  return text.slice(0, maxLength) + '...';
}

export function TruncateWithPopover({ text, maxLength, style }: Props) {
  const truncatedText = truncateText(text, maxLength);

  if (text === truncatedText) {
    return <span>{text}</span>;
  }
  return (
    <Popover>
      <PopoverTrigger asChild>
        <span
          data-testid="TruncateWithPopover-trigger"
          style={{ borderBottom: '1px dotted', cursor: 'pointer' }}
        >
          {truncatedText}
        </span>
      </PopoverTrigger>
      <PopoverContent
        className="TruncateWithPopover__popover"
        style={style}
        align="center"
        side="bottom"
        portal={false}
      >
        {text}
      </PopoverContent>
    </Popover>
  );
}
